import Vue from 'vue';
import numeral from 'numeral';

import './lib/locales/rub';
import './lib/locales/usd';
import './lib/locales/eur';
import './lib/locales/idr';
import './lib/locales/vnd';
import './lib/locales/kzt';
import './lib/locales/inr';

import {
  abbreviate,
  bytes,
  exponential,
  exposedNumeral,
  ordinal,
  percentage,
  separator,
  currency
} from './lib/filters.js';

Vue.prototype.$numeral = {
  abbreviate: abbreviate,
  bytes: bytes,
  exponential: exponential,
  exposedNumeral: exposedNumeral,
  ordinal: ordinal,
  percentage: percentage,
  separator: separator,
  currency: currency,
  _inst: numeral
};

Vue.filter('abbreviate', abbreviate);
Vue.filter('bytes', bytes);
Vue.filter('exponential', exponential);
Vue.filter('numeral', exposedNumeral);
Vue.filter('ordinal', ordinal);
Vue.filter('percentage', percentage);
Vue.filter('separator', separator);
Vue.filter('currency', currency);
